import { createFileRoute } from '@tanstack/react-router'

import { HEAT_PUMP_CHILLER_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { manageRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Gestion des synoptiques PAC / groupe froid. Garde OuiSense et préchargement sont communs aux
// catégories de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/heat-pump/technical/manage/')(manageRouteOptions(HEAT_PUMP_CHILLER_DOMAIN))
